import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from "@angular/router";
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WspFeatureGuard implements CanActivate {
  private readonly router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (environment?.ENABLE_WSP) {
      return true;
    }
    return this.router.parseUrl('/landingpage');
  }
}
